import { useLocalizeMessage } from 'libs.nucleus';
import { SiteUserRoles } from '../../types';
export const useSiteUserRoles = () => {
    const translate = useLocalizeMessage();
    const siteUserRolesObject = {
        [SiteUserRoles.SITE_AUDITOR]: translate('Site auditor'),
        [SiteUserRoles.SITE_RESEARCH_COORDINATOR]: translate('Clinical research coordinator'),
        [SiteUserRoles.SITE_PRINCIPAL_INVESTIGATOR]: translate('Principal investigator'),
        [SiteUserRoles.SITE_CLINICAL_RESEARCH_ASSOCIATE]: translate('Clinical research associate'),
        [SiteUserRoles.SITE_REVIEWER]: translate('Site reviewer'),
    };
    const siteUserRolesOptions = [
        {
            label: siteUserRolesObject[SiteUserRoles.SITE_RESEARCH_COORDINATOR],
            value: SiteUserRoles.SITE_RESEARCH_COORDINATOR,
        },
        {
            label: siteUserRolesObject[SiteUserRoles.SITE_PRINCIPAL_INVESTIGATOR],
            value: SiteUserRoles.SITE_PRINCIPAL_INVESTIGATOR,
        },
        {
            label: siteUserRolesObject[SiteUserRoles.SITE_CLINICAL_RESEARCH_ASSOCIATE],
            value: SiteUserRoles.SITE_CLINICAL_RESEARCH_ASSOCIATE,
        },
        {
            label: siteUserRolesObject[SiteUserRoles.SITE_AUDITOR],
            value: SiteUserRoles.SITE_AUDITOR,
        },
        {
            label: siteUserRolesObject[SiteUserRoles.SITE_REVIEWER],
            value: SiteUserRoles.SITE_REVIEWER,
        },
    ];
    const getSiteUserRolesLabel = (roles) => {
        return roles
            .filter((role) => siteUserRolesObject[role])
            .map((role) => siteUserRolesObject[role])
            .join(', ');
    };
    return {
        siteUserRolesObject,
        siteUserRolesOptions,
        getSiteUserRolesLabel,
    };
};
